import React, { useRef, useState } from 'react';
import './styles.css';
import PropTypes from 'prop-types';

import { Form } from '@unform/web';
import { Input, Checkbox } from '../../../components/Form';
import Button from '../../../components/Button';
import Row from '../../../components/Row';
import Grid from '../../../components/Grid';
import { MdSearch, MdClear } from 'react-icons/md';

function MedicamentoSearch({
  onSearch: handleSearch,
  onClear: handleClearSearch,
}) {
  const formRef = useRef(null);

  const [ref, setRef] = useState('');
  const [startsWith, setStartsWith] = useState(false);

  function resetForm() {
    setRef('');
    setStartsWith(false);
  }

  return (
    <div className='search-container'>
      <Form ref={formRef} onSubmit={handleSearch}>
        <Row>
          <Grid cols='12'>
            <Checkbox
              id='startsWith'
              name='startsWith'
              label='Iniciar com...'
              checked={startsWith}
              value={startsWith}
              onChange={(e) => setStartsWith(e.target.checked)}
            />
          </Grid>
        </Row>

        <Row>
          <Grid cols='12 10'>
            <Input
              id='ref'
              name='ref'
              value={ref}
              onChange={(e) => setRef(e.target.value)}
              placeholder='Pesquise por nome, uso, posologia ou observação ...'
            />
          </Grid>

          <Grid cols='12 2'>
            <Button color='info' type='submit'>
              <MdSearch size={18} />
            </Button>

            <Button
              color='info'
              className='ml-2'
              handleclick={() => {
                handleClearSearch();
                resetForm();
              }}
            >
              <MdClear size={18} />
            </Button>
          </Grid>
        </Row>
      </Form>

      <hr className='divider' />
    </div>
  );
}

MedicamentoSearch.propTypes = {
  onSearch: PropTypes.func.isRequired,
  onClear: PropTypes.func,
};

export default MedicamentoSearch;
